// Translations
import form from '../sections/form/translations/tr'

// Translation: Register > Landing (Turkish)
export default Object.freeze({
	sections: { form }
})
